import type { VoidFunctionComponent } from 'react';

import { ModalViewRelationshipsBody } from '../../../dependencies/ModalViewRelationships';

import styles from '../DependencyDrawer.module.less';

type DependencyPathsProps = {
  rootProjectLocator: string;
  dependencyLocator: string;
  dependencyTitle: string;
};

export const DependencyPaths: VoidFunctionComponent<DependencyPathsProps> = ({
  rootProjectLocator,
  dependencyLocator,
  dependencyTitle,
}) => {
  const revision = {
    locator: dependencyLocator,
    project: {
      title: dependencyTitle,
    },
  };
  return (
    <>
      <div className={styles.header}>Paths</div>
      <ModalViewRelationshipsBody parentLocator={rootProjectLocator} revision={revision} />
    </>
  );
};
